import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import { Checkbox, Group, Loader, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import RentIconBlue from '../../../../../assets/images/module/general/RentIcon.svg';
import RentIcon from '../../../../../assets/images/module/general/RentIconGray.svg';
import ReceiptsIcon from '../../../../../assets/images/module/general/ReceiptsIconGray.svg';
import ReceiptsIconBlue from '../../../../../assets/images/module/general/ReceiptsIconBlue.svg';
import EmptyIcon from '../../../../../assets/images/EmptyReciept.svg';
import { NumericFormat } from 'react-number-format';
import CardSelection from '../CardSelection/CardSelection';
import { connect } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Autoload from '../../../../Autoload';
import dayjs from 'dayjs';
import accounting from 'accounting';
import ReceiptRecord from '../ReceiptRecord';
import ReceiptsList from '../../../../../views/pages/Module/Receipt/ReceiptsList';
import ReceiptAssigmentRemoveConfirmationModal from './ReceiptAssigmentRemoveConfirmationModal';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;
const SMALLER_MOBILE_SIZE = 500;

const tableCellStyle = {
    whiteSpace: 'nowrap', 
    overflow: 'hidden', 
    textOverflow: 'ellipsis', 
    fontSize: '14px', 
    fontFamily: 'Inter, sans-serif', 
    height: 'auto !important',
    fontWeight: '400',
    borderTop: '8px solid white'
}

export class SelectReceiptsForReceiptAssigmentModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    isSmallerMobile: window.innerWidth <= SMALLER_MOBILE_SIZE,
    selectedReceipts: [],
    calledOpenWarningForReceiptRemoval: false,
    openRemoveReceiptAssignmentModal: false,
    updateReceipts: false
  };

  componentDidMount(){
    window.addEventListener('resize', this.handleResize);
    this.setState({selectedReceipts: this.props.selectedReceiptsFromParent});
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps){
    if(this.props.selectedReceiptsFromParent.length !== prevProps.selectedReceiptsFromParent.length){
      this.setState({selectedReceipts: this.props.selectedReceiptsFromParent});
    }else if(this.props.selectedReceiptsFromParent.filter((selectedReceiptFromParent)=> this.state.selectedReceipts.find((selectedReceipt)=> selectedReceiptFromParent === selectedReceipt) === undefined).length > 0 && this.state.calledOpenWarningForReceiptRemoval === false){
      this.setState({calledOpenWarningForReceiptRemoval: true, openRemoveReceiptAssignmentModal: true});
    }
  }

  handleResize = () => {
    // TODO: this causes data refetch on the meters reading details screen...
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
    if (window.innerWidth <= TABLET_SIZE) {
      this.setState({ isTablet: true });
    } else {
      this.setState({ isTablet: false });
    }

    if (window.innerWidth <= SMALLER_MOBILE_SIZE) {
      this.setState({ isSmallerMobile: true });
    } else {
      this.setState({ isSmallerMobile: false });
    }
  };
  
  render() {
    const { open, toggle, className, saveSelectedReceipts, selectedReceiptsFromParent, getReceipts, edit, openAddReceiptModal, receipts, receiptsLoader=false, currentCp, removeReceipt, updateReceipt, nonHeatingCP=false, isSecured } = this.props;
    const { selectedReceipts, isMobile, isTablet, isSmallerMobile, openRemoveReceiptAssignmentModal, updateReceipts } = this.state;

    console.log('selectedReceipts: ', selectedReceipts, selectedReceiptsFromParent);
    console.log('receiptsLoader: ', receiptsLoader);

    console.log('currentCp: ', currentCp);

    return (
      <CustomModal
        heading={`Beleg zuordnen oder erzeugen${nonHeatingCP ? (currentCp?.costTypeName ? ` (${currentCp?.costTypeName})` : '') : (currentCp?.heatingCostType ? ` (${currentCp?.heatingCostType})` : '')}`}
        //headingClassName={'assign-receipt-transaction-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
        style={{
            minWidth: isSmallerMobile ? 'auto' : isMobile ? '370px' : isTablet ? '800px' : '1200px'
        }}
        styleBody={{background: '#f7f7fa'}}
      >
        <Stack justify={receiptsLoader ? 'center' : 'space-between'} align={receiptsLoader && 'center'} style={{minHeight: '450px'}}>
          {receiptsLoader ?
          <Loader type='dots'/>
          :
          <>
            <Group justify='center' align={'center'} style={{height: '100%'}}>
              <ReceiptsList 
              receiptAssignment={true}
              isSecured={isSecured}
              openAddReceiptModal={()=> openAddReceiptModal()}
              edit={edit}
              receipts={receipts}
              selectedReceipts={selectedReceiptsFromParent} 
              updateSelectedReceipts={(selectedReceipts)=> this.setState({selectedReceipts})}
              removeReceipt={(receiptId)=> removeReceipt(receiptId)}
              updateReceipt={(receipt)=> updateReceipt(receipt)}
              // updateReceipts={updateReceipts}
              // setUpdateReceipts={()=> this.setState({updateReceipts: false})}
              //getReceipts={(newAddedReceipt=null)=> getReceipts(newAddedReceipt)}
              />
            </Group>
            <Group justify="space-between">
              <div>
                  <ColorButton
                  text={'Abbrechen'}
                  className='gray-btn'
                  onClick={()=> toggle()}
                  />
              </div>
              <div>
                  <ColorButton
                  text={'Speichern'}
                  className='purple-btn'
                  onClick={()=> saveSelectedReceipts(selectedReceipts)}
                  disabled={isSecured}
                  />
              </div>
            </Group>
          </>}
          
        </Stack>

        {openRemoveReceiptAssignmentModal &&
        <ReceiptAssigmentRemoveConfirmationModal
        open={openRemoveReceiptAssignmentModal}
        //newAmount={newAmount}
        history={this.props.history}
        toggle={()=> this.setState({openRemoveReceiptAssignmentModal: false}, ()=> {
          let removedReceipts = this.props.selectedReceiptsFromParent.filter((selectedReceiptFromParent)=> this.state.selectedReceipts.find((selectedReceipt)=> selectedReceiptFromParent === selectedReceipt) === undefined);
          if(removedReceipts.length > 0){
            let {selectedReceipts} = this.state;
            removedReceipts.forEach((receipt)=> selectedReceipts.push(receipt));
            this.setState({selectedReceipts, updateReceipts: true});
          }
        })}
        removeReceipt={()=> this.setState({openRemoveReceiptAssignmentModal: false})}
        />}
      </CustomModal>
    );
  }
}

const mapStateToProps = (state) => {
    return {
      propertySelected: state.generalReducer.property,
      rentalUnits: state.tenantDataReducer.rentalUnits
    };
  };
  
export default connect(mapStateToProps)(SelectReceiptsForReceiptAssigmentModal);
